import axios from 'axios'
import liens from '../../../enum/liens'
import { AjoutFichierBackModel, CreationProcedureModel, FetchUUIDModel, SignataireValidateurModel, SuppressionFichierBackModel } from '../types/CreationProcedureModel'
import { OktaUsersResponseType, ResponseType } from '../../../types/responseType'


export const fetchUuid = (): Promise<FetchUUIDModel> =>
	axios(liens.uuidApi)
		.then((res) => {
			return res.data
		})

export const sendFile = (infoFichier: AjoutFichierBackModel): Promise<string> => axios.post(liens.ajoutFichierApi, infoFichier)
	.then((response) => response.data)


export const deleteFile = (infoFichier: SuppressionFichierBackModel): Promise<string> => axios.post(liens.suppressionFichierApi, infoFichier)
	.then((response) => response.data)

export const creerProcedure = (informations: CreationProcedureModel): Promise<ResponseType> => axios.post(liens.creerProcedureApi, informations)

export const annulerProcedure = (uuid: { uuid: string }): Promise<ResponseType> => axios.post(liens.annulerProcedureApi, uuid)

export const listeUtilisateurokta = (informations: string): Promise<OktaUsersResponseType> => axios.post(liens.listeUtilisateuroktaApi, { search: informations })


export const listeContactYousign = (informations: string): Promise<SignataireValidateurModel[]> => axios.post(liens.listeContactApi, { search: informations })
	.then((response) => response.data)

